import {ref} from 'vue';

const audioTag = document.createElement('audio');

export const audioCurrentPosition = ref(0);
export const audioDuration = ref(0);
export const audioLoading = ref(true);
export const audioPlaying = ref(false);
export const audioLimit = ref(0);

setInterval(() => {
	if (audioLimit.value > 0 && audioPlaying.value && audioTag.currentTime > audioLimit.value)
		stopAudio();
}, 50);

export function setAudio(url: string) {
	stopAudio();
	audioLoading.value = true;
	audioTag.src = url;
}

export async function playAudio() {
	stopAudio();
	return audioTag.play();
}

export function stopAudio() {
	audioTag.pause();
	audioTag.currentTime = 0;
	audioPlaying.value = false;
}

const updateDuration = () => {
	if (audioPlaying.value) {
		requestAnimationFrame(updateDuration);
		audioCurrentPosition.value = audioTag.currentTime;
	} else {
		audioCurrentPosition.value = 0;
	}
};

const playListener = () => {
	audioPlaying.value = true;
	requestAnimationFrame(updateDuration);
};
const endListener = () => {
	audioPlaying.value = false;
	stopAudio();
};

audioTag.addEventListener('play', playListener);
audioTag.addEventListener('playing', playListener);
audioTag.addEventListener('ended', endListener);
audioTag.addEventListener('pause', endListener);

audioTag.addEventListener('durationchange', () => {
	audioDuration.value = audioTag.duration;
});
audioTag.addEventListener('canplay', () => {
	audioLoading.value = false;
});
